import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface Step {
  name: string;
  description?: string;
}
interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
  accentColor?: 'cyan' | 'purple';
}
export function StepIndicator({
  steps,
  currentStep,
  accentColor = 'cyan'
}: StepIndicatorProps) {
  const activeColor = accentColor === 'cyan' ? 'bg-cyan-500 text-slate-900' : 'bg-purple-500 text-white';
  const completedColor = accentColor === 'cyan' ? 'bg-cyan-500/20 text-cyan-400 border-cyan-500/50' : 'bg-purple-500/20 text-purple-400 border-purple-500/50';
  const inactiveColor = 'bg-slate-800 text-slate-500 border-slate-700';
  return <div className="w-full mb-12" data-id="element-625">
      <div className="flex justify-between relative" data-id="element-626">
        {/* Connecting Line */}
        <div className="absolute top-1/2 left-0 w-full h-0.5 bg-slate-800 -translate-y-1/2 z-0" data-id="element-627" />
        <div className={`absolute top-1/2 left-0 h-0.5 -translate-y-1/2 z-0 transition-all duration-500 ${accentColor === 'cyan' ? 'bg-cyan-500' : 'bg-purple-500'}`} style={{
        width: `${(currentStep - 1) / (steps.length - 1) * 100}%`
      }} data-id="element-628" />

        {steps.map((step, index) => {
        const stepNum = index + 1;
        const isCompleted = stepNum < currentStep;
        const isActive = stepNum === currentStep;
        return <div key={index} className="relative z-10 flex flex-col items-center" data-id="element-629">
              <motion.div initial={false} animate={{
            scale: isActive ? 1.1 : 1,
            borderColor: isActive ? accentColor === 'cyan' ? '#06b6d4' : '#a855f7' : isCompleted ? accentColor === 'cyan' ? '#06b6d4' : '#a855f7' : '#334155'
          }} className={`w-10 h-10 rounded-full flex items-center justify-center border-2 font-bold text-sm transition-colors duration-300 ${isActive ? activeColor : isCompleted ? completedColor : inactiveColor}`} data-id="element-630">
                {isCompleted ? <Check size={16} data-id="element-631" /> : stepNum}
              </motion.div>
              <div className="absolute top-12 w-32 text-center" data-id="element-632">
                <span className={`text-xs font-medium transition-colors duration-300 ${isActive ? 'text-white' : 'text-slate-500'}`} data-id="element-633">
                  {step.name}
                </span>
              </div>
            </div>;
      })}
      </div>
    </div>;
}